var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmpathyMap(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1562",
    "data-name": "Rectangle 1562",
    width: 15.511,
    height: 15.918,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Empathy_Map",
    "data-name": "Empathy Map",
    transform: "translate(-590 -301.662)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_447",
    "data-name": "Ellipse 447",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(590 301.662)",
    fill: "#ee3d4a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_31622",
    "data-name": "Group 31622",
    transform: "translate(597.246 308.203)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1554",
    "data-name": "Rectangle 1554",
    width: 1.727,
    height: 1.914,
    transform: "translate(10.31 7.892)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1555",
    "data-name": "Rectangle 1555",
    width: 1.727,
    height: 1.914,
    transform: "translate(5.753 10.357)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1556",
    "data-name": "Rectangle 1556",
    width: 1.727,
    height: 1.914,
    transform: "translate(3.474 7.893)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1557",
    "data-name": "Rectangle 1557",
    width: 1.727,
    height: 1.914,
    transform: "translate(3.474 10.357)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_31621",
    "data-name": "Group 31621",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_31620",
    "data-name": "Group 31620",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11978",
    "data-name": "Path 11978",
    d: "M5.68,1.967a.7.7,0,1,0-.494.2.7.7,0,0,0,.494-.2",
    transform: "translate(2.57 0.444)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11979",
    "data-name": "Path 11979",
    d: "M5.63,6.465a.136.136,0,0,0,.124-.075A16.178,16.178,0,0,0,7.545,1.917a1.916,1.916,0,0,0-3.832,0A16.159,16.159,0,0,0,5.5,6.389a.136.136,0,0,0,.126.075M4.38,1.917a1.248,1.248,0,1,1,.366.884,1.25,1.25,0,0,1-.366-.884",
    transform: "translate(2.126 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1558",
    "data-name": "Rectangle 1558",
    width: 1.727,
    height: 1.914,
    transform: "translate(10.31 10.357)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1559",
    "data-name": "Rectangle 1559",
    width: 1.727,
    height: 1.914,
    transform: "translate(8.031 7.893)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1560",
    "data-name": "Rectangle 1560",
    width: 1.727,
    height: 1.914,
    transform: "translate(5.753 7.893)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11980",
    "data-name": "Path 11980",
    d: "M15.511,13.623a.749.749,0,0,1-.749.749H.749A.746.746,0,0,1,0,13.623V3.45A.749.749,0,0,1,.749,2.7h4.9c.074.176.154.36.239.552H.749a.2.2,0,0,0-.2.2V13.623a.2.2,0,0,0,.2.2H14.762a.2.2,0,0,0,.2-.2V3.45a.2.2,0,0,0-.2-.2H9.618c.085-.192.165-.376.239-.552h4.9a.752.752,0,0,1,.749.75Z",
    transform: "translate(0 1.546)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1561",
    "data-name": "Rectangle 1561",
    width: 1.727,
    height: 1.914,
    transform: "translate(8.031 10.357)",
    fill: "#fff"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpathyMap);
export default __webpack_public_path__ + "static/media/Empathy-Map.b3459a8868bc3d91ae4e5da06fac0d56.svg";
export { ForwardRef as ReactComponent };